import { FormArray } from '@angular/forms';

export function arrayNotEmptyValidator(control: FormArray): any {

  if (!control.length) {
      return { notEmpty: true };
  }

  return null;
}
